import Overview from '@/components/overview';
import { SeoHead } from '@/components/seo-head';
import { getAbsoluteUrl } from '@/utils/get-absolute-url';
import { loadMessages } from '@/utils/i18n';
import { useLayout } from '@/utils/use-layout';
import { t } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { GetServerSidePropsContext, InferGetServerSidePropsType } from 'next';

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const baseUrl = getAbsoluteUrl(ctx.req);
  const messages = await loadMessages(ctx?.locale);
  return { props: { baseUrl, messages } };
}

export default function FreshPerspectivesPage(
  props: InferGetServerSidePropsType<typeof getServerSideProps>
) {
  const { baseUrl } = props;

  useLayout('white');
  useLingui();

  return (
    <>
      <SeoHead
        baseUrl={baseUrl}
        pageTitle={t({ message: `Overview`, id: 'overview.page-title' })}
      />
      <Overview />
    </>
  );
}
